export class IncidentQueueApiError extends Error {
  constructor(
    public readonly uuid: string,
    public override readonly message: string,
  ) {
    super(message)
  }
}
